import { ChangeEvent, FC, useEffect, useState } from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";

import styles from "./styles.module.scss";
//assets
import { CloseIcon } from "../../assets";
//components
import { Button } from "../../components";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onAccept: () => void;
  isLoading: boolean;
  title: string;
  text?: string;
  setIsmultiple?: (value: boolean) => void;
}

const AgreementModal: FC<Props> = ({
  isOpen,
  setIsOpen,
  onAccept,
  isLoading: loading,
  title,
  text,
  setIsmultiple,
}): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const onAcceptHandler = () => {
    setIsOpen(false);
    onAccept();
    setIsmultiple?.(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      shouldFocusAfterRender={false}
      onRequestClose={() => setIsOpen(false)}
      overlayClassName={styles.overlay}
      className={styles.modal}
      ariaHideApp={false}
    >
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <h5>{title}</h5>{" "}
          <CloseIcon
            onClick={() => setIsOpen(false)}
            className={styles.closeBtn}
          />
        </div>
        <div className={styles.questionBody}>
          <h2>{text ? text : "Save changes?"}</h2>
        </div>
        <div className={styles.btnContainer}>
          <Button
            title={"Confirm"}
            loading={isLoading}
            onClick={onAcceptHandler}
            style={{ border: "none", borderRadius: "16px", width: "150px" }}
          />
          <div>
            <Button
              title={"Cancel"}
              onClick={() => setIsOpen(false)}
              loading={isLoading}
              style={{
                border: "none",
                // background: "background: rgb(228, 228, 228)",
                borderRadius: "16px",
                color: "black",
                width: "150px",
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AgreementModal;
